import "./main.css";
import {jsx as $4eKkr$jsx, jsxs as $4eKkr$jsxs} from "react/jsx-runtime";
import {useState as $4eKkr$useState, useRef as $4eKkr$useRef, useEffect as $4eKkr$useEffect, useContext as $4eKkr$useContext, useCallback as $4eKkr$useCallback, createContext as $4eKkr$createContext, Children as $4eKkr$Children, cloneElement as $4eKkr$cloneElement} from "react";
import $4eKkr$clsx from "clsx";










const $357b51f3919a77b3$export$c11a9f7a2966b833 = (0, $4eKkr$createContext)(null);


const $6e87d246c40ffc7f$var$ContextProvider = ({ hide: hide, children: children })=>{
    return /*#__PURE__*/ (0, $4eKkr$jsx)((0, $357b51f3919a77b3$export$c11a9f7a2966b833).Provider, {
        value: {
            hide: hide
        },
        children: children
    });
};
var $6e87d246c40ffc7f$export$2e2bcd8739ae039 = $6e87d246c40ffc7f$var$ContextProvider;


const $298f1a4cb803fac0$var$MenuItem = ({ children: children, onClick: onClick, className: className, disabled: disabled = false, ...rest })=>{
    const context = (0, $4eKkr$useContext)((0, $357b51f3919a77b3$export$c11a9f7a2966b833));
    const [state, setState] = (0, $4eKkr$useState)({
        clicked: false,
        eventRef: null
    });
    const handleClick = (event)=>{
        event.stopPropagation();
        if (onClick) setState({
            clicked: true,
            eventRef: event
        });
    };
    const handleAnimationEnd = (0, $4eKkr$useCallback)(()=>{
        setState((prev)=>({
                ...prev,
                clicked: false
            }));
        if (state.clicked && state.eventRef) {
            context?.hide();
            onClick(state.eventRef);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.clicked,
        state.eventRef
    ]);
    const classNames = (0, $4eKkr$clsx)('react-context-menu__item', className, {
        'react-context-menu__item--disabled': disabled,
        'react-context-menu__item--clicked': state.clicked
    });
    return /*#__PURE__*/ (0, $4eKkr$jsx)("button", {
        ...rest,
        onClick: handleClick,
        onAnimationEnd: handleAnimationEnd,
        className: classNames,
        "aria-disabled": disabled,
        disabled: disabled,
        role: "menuitem",
        type: "button",
        tabIndex: -1,
        children: children
    });
};
var $298f1a4cb803fac0$export$2e2bcd8739ae039 = $298f1a4cb803fac0$var$MenuItem;




const $aaac24ba69a5e95e$var$Separator = ({ className: className, ...rest })=>{
    const classNames = (0, $4eKkr$clsx)('react-context-menu__separator', className);
    return /*#__PURE__*/ (0, $4eKkr$jsx)("hr", {
        className: classNames,
        ...rest
    });
};
var $aaac24ba69a5e95e$export$2e2bcd8739ae039 = $aaac24ba69a5e95e$var$Separator;





const $55f2ecb58225d6c7$export$7ad24bcefcc2f353 = 150;
const $55f2ecb58225d6c7$export$e7e0d200325546b7 = 'react-context-menu__submenu-right';
const $55f2ecb58225d6c7$export$8107855dbd9d8845 = 'react-context-menu__submenu-bottom';
const $55f2ecb58225d6c7$export$ac4c9a37b5ef49c = [
    'click',
    'resize',
    'scroll',
    'contextmenu'
];



const $fc7df41ca676b6cd$export$47774cf7fb07bfc4 = (e)=>{
    const position = {
        x: e.clientX,
        y: e.clientY
    };
    if (!position.x || position.x < 0) position.x = 0;
    if (!position.y || position.y < 0) position.y = 0;
    return position;
};
const $fc7df41ca676b6cd$export$82fe588c13ee14ad = (position, element)=>{
    if (!element) return position;
    let { x: x, y: y } = position;
    const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = element;
    if (x + offsetWidth > innerWidth) x -= x + offsetWidth - innerWidth;
    if (y + offsetHeight > innerHeight) y -= y + offsetHeight - innerHeight;
    return {
        x: x,
        y: y
    };
};
const $fc7df41ca676b6cd$export$f673a647b4ec5ab5 = (children)=>{
    const filteredItems = (0, $4eKkr$Children).toArray(children).filter(Boolean);
    return filteredItems.map((item)=>(0, $4eKkr$cloneElement)(item));
};


const $dcc0e39ffa899b04$var$SubMenu = ({ label: label, children: children, className: className, disabled: disabled = false, ...rest })=>{
    const [active, setActive] = (0, $4eKkr$useState)(false);
    const timeoutRef = (0, $4eKkr$useRef)(null);
    const itemRef = (0, $4eKkr$useRef)(null);
    const subMenuRef = (0, $4eKkr$useRef)(null);
    (0, $4eKkr$useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const clearTimer = ()=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    const calculatePosition = ()=>{
        if (subMenuRef.current && itemRef.current) {
            clearTimer();
            setActive(true);
            // Reset position styling
            subMenuRef.current.style.top = '0';
            subMenuRef.current.classList.remove((0, $55f2ecb58225d6c7$export$e7e0d200325546b7), (0, $55f2ecb58225d6c7$export$8107855dbd9d8845));
            const { height: height } = itemRef.current.getBoundingClientRect();
            const { right: right, bottom: bottom } = subMenuRef.current.getBoundingClientRect();
            if (right > window.innerWidth) subMenuRef.current.classList.add((0, $55f2ecb58225d6c7$export$e7e0d200325546b7));
            if (bottom - window.innerHeight > 0) {
                subMenuRef.current.style.top = `${window.innerHeight - bottom - height}px`;
                subMenuRef.current.classList.add((0, $55f2ecb58225d6c7$export$8107855dbd9d8845));
            }
        }
    };
    const onLeave = ()=>{
        clearTimer();
        timeoutRef.current = setTimeout(()=>{
            setActive(false);
        }, (0, $55f2ecb58225d6c7$export$7ad24bcefcc2f353));
    };
    const classNames = (0, $4eKkr$clsx)('react-context-menu__item', className, {
        'react-context-menu__item--disabled': disabled
    });
    return /*#__PURE__*/ (0, $4eKkr$jsxs)("div", {
        ...rest,
        ref: itemRef,
        className: classNames,
        "aria-haspopup": "true",
        role: "menuitem",
        tabIndex: -1,
        onMouseEnter: calculatePosition,
        onMouseLeave: onLeave,
        onClick: (event)=>event.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $4eKkr$jsxs)("div", {
                className: "react-context-menu__label",
                children: [
                    label,
                    /*#__PURE__*/ (0, $4eKkr$jsx)("span", {
                        className: "react-context-menu__arrow"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4eKkr$jsx)("div", {
                ref: subMenuRef,
                style: {
                    visibility: active ? 'visible' : 'hidden'
                },
                className: "react-context-menu__submenu",
                children: (0, $fc7df41ca676b6cd$export$f673a647b4ec5ab5)(children)
            })
        ]
    });
};
var $dcc0e39ffa899b04$export$2e2bcd8739ae039 = $dcc0e39ffa899b04$var$SubMenu;





const $ed036765bdd2b2a8$var$ContextMenu = ({ triggerId: triggerId, children: children, className: className, triggerEvent: triggerEvent = 'contextmenu', animateExit: animateExit = true, ...rest })=>{
    const [state, setState] = (0, $4eKkr$useState)({
        active: false,
        leaving: false,
        position: {
            x: 0,
            y: 0
        }
    });
    const contextMenuRef = (0, $4eKkr$useRef)(null);
    const show = (event)=>{
        let position = (0, $fc7df41ca676b6cd$export$47774cf7fb07bfc4)(event);
        position = (0, $fc7df41ca676b6cd$export$82fe588c13ee14ad)(position, contextMenuRef.current);
        if (JSON.stringify(state.position) === JSON.stringify(position)) return;
        event.stopPropagation();
        event.preventDefault();
        setState((prev)=>({
                ...prev,
                active: true,
                position: position
            }));
    };
    const hide = ()=>{
        if (animateExit) setState((prev)=>({
                ...prev,
                leaving: true
            }));
        else setState((prev)=>({
                ...prev,
                active: false
            }));
    };
    const handleAnimationEnd = ()=>{
        const { leaving: leaving, active: active } = state;
        if (leaving && active) setState(()=>({
                position: {
                    x: 0,
                    y: 0
                },
                active: false,
                leaving: false
            }));
    };
    (0, $4eKkr$useEffect)(()=>{
        const { position: position } = state;
        if (state.active) setState((prev)=>({
                ...prev,
                position: (0, $fc7df41ca676b6cd$export$82fe588c13ee14ad)(position, contextMenuRef.current)
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.active
    ]);
    (0, $4eKkr$useEffect)(()=>{
        const trigger = document.getElementById(triggerId);
        if (trigger) trigger.addEventListener(triggerEvent, show);
        if (state.active) for (const event of (0, $55f2ecb58225d6c7$export$ac4c9a37b5ef49c))window.addEventListener(event, hide);
        return ()=>{
            trigger?.removeEventListener(triggerEvent, show);
            for (const event of (0, $55f2ecb58225d6c7$export$ac4c9a37b5ef49c))window.removeEventListener(event, hide);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerId,
        state.active,
        state.position,
        show,
        hide
    ]);
    if (!state.active) return null;
    const classNames = (0, $4eKkr$clsx)('react-context-menu', className, {
        'react-context-menu--exit': state.leaving
    });
    return /*#__PURE__*/ (0, $4eKkr$jsx)("div", {
        ...rest,
        className: classNames,
        style: {
            left: state.position.x,
            top: state.position.y
        },
        role: "menu",
        ref: contextMenuRef,
        onAnimationEnd: handleAnimationEnd,
        onClick: (event)=>event.stopPropagation(),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $4eKkr$jsx)((0, $6e87d246c40ffc7f$export$2e2bcd8739ae039), {
            hide: hide,
            children: (0, $fc7df41ca676b6cd$export$f673a647b4ec5ab5)(children)
        })
    });
};
$ed036765bdd2b2a8$var$ContextMenu.Item = (0, $298f1a4cb803fac0$export$2e2bcd8739ae039);
$ed036765bdd2b2a8$var$ContextMenu.Separator = (0, $aaac24ba69a5e95e$export$2e2bcd8739ae039);
$ed036765bdd2b2a8$var$ContextMenu.SubMenu = (0, $dcc0e39ffa899b04$export$2e2bcd8739ae039);
var $ed036765bdd2b2a8$export$2e2bcd8739ae039 = $ed036765bdd2b2a8$var$ContextMenu;










export {$ed036765bdd2b2a8$export$2e2bcd8739ae039 as ContextMenu, $298f1a4cb803fac0$export$2e2bcd8739ae039 as MenuItem, $aaac24ba69a5e95e$export$2e2bcd8739ae039 as Separator, $dcc0e39ffa899b04$export$2e2bcd8739ae039 as SubMenu, $6e87d246c40ffc7f$export$2e2bcd8739ae039 as ContextProvider, $357b51f3919a77b3$export$c11a9f7a2966b833 as ContextMenuContext};
//# sourceMappingURL=main.js.map
